<template>
	<div class="user_index">
				<!-- 公共头部 -->
		<div class="per-line-40 black top-box">
			<div class="fl">歡迎來到香港中國企業協會</div>
			<div class="fr">
				<span v-if="$store.state.userName === ''">未登錄</span>
				<span v-else>歡迎 <span class="blue">{{ $store.state.userName }}</span> <span @click="exitAccount()" class="c">退出</span></span>
				<span class="c mar-lef-15" @click="goArticleDetail(2)">關於我們</span>
				<span @click="goArticleDetail(3)" class="mar-lef-15 c">聯系我們</span>
			</div>
		</div>
		<div class="pos-relative" style="height: 272px; ">
			<img src="static/img/banner1.jpg" class="banner-box" height="272" style="opacity: 0.4; ">
			<div class="pos-absolute" style="width: 500px; left: 10%; top: 45px;">
				<img src="static/img/logo.png" class="pos-absolute banner-box-logo width-100per">
			</div>
			<!-- 导航栏 -->
			<div class="per-line-50 red-b pos-absolute font-size-16 white width-100per" style="bottom: 10px;">
				<div style="width: 1200px; margin: 0 auto; " class="over-hidden">
					<div class="fl per-line-50 ellip tl c white" @click="goShopIndex()">首頁</div>
					<mu-menu class="fl per-line-50 tl c over-hidden white" style=" margin-left: 50px;" placement="bottom-start" open-on-hover :key='i' v-for="(category, i) in categorys">
						<div style="background-color: transparent;" class="fl per-line-50 ellip tl c white">{{ category.title }}</div>
						<mu-list slot="content" class="red-b white" :key='j' v-for="(categoryChild, j) in category.child">
							<mu-list-item button @click="goSortIndex(categoryChild.id, categoryChild.title)">
								<mu-list-item-title class="white">{{ categoryChild.title }}</mu-list-item-title>
							</mu-list-item>
						</mu-list>
					</mu-menu>
				</div>
			</div>
		</div>
		<!-- 公共头部 -->
		<div class="over-hidden top-box white-b pad-lef-15 pad-rig-15 pad-bot-15" style="min-height: 600px;">
			<div class="width-150 fl">
				<div class="per-line-40 white red-b-opacity mar-top-15 tc">
					用戶管理
				</div>
				<div class="white-b tc over-hidden">
					<div @click="changeSelect(0)" class="black per-line-40 ellip c gray-b" :class="{'yellow-b-opacity': selectI === 0}">
						用戶信息
					</div>
					<div @click="changeSelect(1)" class="black per-line-40 ellip c gray-b" :class="{'yellow-b-opacity': selectI === 1}">
						瀏覽記錄
					</div>
				</div>
			</div>
			<div v-show="!showViewRecord" class="fl width-70per mar-lef-2per mar-top-15">
				<div class="over-hidden white-b tl width-50per mar-lef-25per">
					<form id="imageUploadForm" ref='uploadPictureForm' name="formen">
						<div class="tc height-100 width-100 border-1 fl c border-rad-50per" style="line-height: 100px; background-size: 100% 100%; background-position: center; " onclick="document.formen.myfile.click()" :style="'background-image: url('+ headimgurl +')'">
							<span>{{ uploadMsg }}</span>
						</div>
						<input ref="limiteImage" id="file" class="fr limiteImg" style="height: 30px; width: 300px; text-align: right;" type="file" name="myfile" @change="uploadPicture" accept="image/*" hidden>
					</form>
					<div class="fl height-100 mar-top-15 mar-lef-15">
						<div class="tl">歡迎您, {{ username }}</div>
						<div class="tl">上次登錄: {{ logintime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
						<div class="tl">註冊時間: {{ regtime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
					</div>
				</div>
				<div class="white-b tl pad-15">
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">通訊地址</span>
						<input type="text" placeholder="中文" v-model="ch_address" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">通訊地址</span>
						<input type="text" placeholder="英文" v-model="en_address" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">性别</span>
						<select v-model="sex" class="fl input-style width-48per mar-lef-2per">
							<option value="1">男</option>
							<option value="2">女</option>
						</select>
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">Tel</span>
						<input type="text" v-model="tel" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">Fax</span>
						<input type="text" v-model="fax" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">E-Mail</span>
						<input type="text" v-model="email" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">現職單位</span>
						<input type="text" v-model="xianzhi_unit" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">股東單位</span>
						<input type="text" v-model="gudong_unit" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">持股比例</span>
						<input type="text" v-model="chigu_rate" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">職位</span>
						<input type="text" v-model="job" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">主要業務</span>
						<input type="text" v-model="main_business" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="height-50 mar-top-5 over-hidden">
						<span class="width-30per fl tr ellip per-line-50">何時來港工作</span>
						<mu-date-input :underlineShow="false" class="fl width-48per height-50 mar-lef-2per border-1" v-model="gotime" :solo='true' format="YYYY-MM-DD"></mu-date-input>
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">由何地來港</span>
						<input type="text" v-model="wherefrom" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">最後畢業院校</span>
						<input type="text" v-model="graduate_shcool" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">獲得學位</span>
						<input type="text" v-model="degree" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">專業</span>
						<input type="text" v-model="major" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">內地最後任職機構或就讀學校</span>
						<input type="text" v-model="last_work_in" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">內地永久通訊地址</span>
						<input type="text" v-model="forever_address" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">本人專長</span>
						<input type="text" v-model="skill" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">對協會的期望</span>
						<input type="text" v-model="expect" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip width-100 c" style="margin: 5px auto 0;">
						<div class="per-line-30 tc red-b-opacity white" @click="complete()">修改</div>
					</div>
				</div>
			</div>
			<div v-show="showViewRecord" class="white-b fl width-70per mar-lef-2per mar-top-15">
				<div v-for="(viewRecord, i) in viewRecords" class="tl pad-15 font-size-16 over-hidden" :class="{'yellow-b-opacity': i % 2 === 0}">
					<div class="fl mar-top-5">
						<div class="font-size-14">{{ viewRecord.title || '該分類或者文章已被刪除!' }}</div>
						<div class="font-size-14">{{ viewRecord.addtime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
					</div>
					<div class="fr pos-relative">
						<img @click="removeViewRecord(viewRecord.id)" src="static/img/delete.png" class="height-24 pos-absolute c" style="right: 5px; top: 13px;">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'user_index',
	data () {
		return {
			selectI: 0,
			navs: [],
			guide_id: 12,
			contextAll: '',
			showViewRecord: false,
			uploadMsg: '上傳頭像',
			headimgurl: '',
			logintime: '',
			regtime: '',
			username: '',
			type: 1,
			ch_address : '',
			en_address : '',
			tel : '',
			fax : '',
			email : '',
			xianzhi_unit : '',
			gudong_unit : '',
			chigu_rate : '',
			job : '',
			main_business : '',
			gotime : '',
			wherefrom : '',
			graduate_shcool : '',
			degree : '',
			major : '',
			last_work_in : '',
			forever_address : '',
			skill : '',
			expect : '',
			sex: '',
			viewRecords: [],
			categorys: [],
		}
	},
	created () {

	},
	mounted () {
		let that = this
		that.c_ajax({}, 'api.php/CmsCategory/lists', function (value) {
			for (let v of value.data) {
				if (v.id !== 1 && v.id !== 2 && v.id !== 147) {
					that.categorys.push(v)
				}
			}
		})
		// 用户信息
		that.c_ajax({user_id: that.$store.state.user_id }, 'api.php/User/detail', function (value) {
			if (value.data.status === 10001) {
				that.logintime = value.data.detail.logintime
				that.regtime = value.data.detail.regtime
				that.username = value.data.detail.username
				that.sex = value.data.detail.sex
				that.headimgurl = value.data.detail.headimgurl
				that.type = value.data.detail.type

				let obj = value.data.detail.ruhui_info
				that.ch_address = obj.ch_address
				that.en_address = obj.en_address
				that.tel = obj.tel
				that.fax = obj.fax
				that.email = obj.email
				that.xianzhi_unit = obj.xianzhi_unit
				that.gudong_unit = obj.gudong_unit
				that.chigu_rate = obj.chigu_rate
				that.job = obj.job
				that.main_business = obj.main_business
				that.gotime = that.timestampToTime(obj.gotime / 1000)
				that.wherefrom = obj.wherefrom
				that.graduate_shcool = obj.graduate_shcool
				that.degree = obj.degree
				that.major = obj.major
				that.last_work_in = obj.last_work_in
				that.forever_address = obj.forever_address
				that.skill = obj.skill
				that.expect = obj.expect

				if (!that.headimgurl) {
					that.uploadMsg = '上傳頭像'
				} else {
					that.uploadMsg = ''
				}

			} else {
				that.showDialog(value.data.msg)
			}
		})

		// 浏览记录
		that.getViewRecords()
	},
	methods: {
		uploadPicture (e) {
			let fd = new FormData(), file = e.target.files[0], that = this
			if (file.size >= 2000*1024) {
				that.showDialog('圖片不能大於2M，請重新上傳')
				that.$refs.uploadPictureForm[0].reset()
				return
			}
			fd.append('myfile', file)
			this.$ajax.post(this.urlPrefix + 'api.php/Plus/upload_img?token=' + this.$store.state.token, fd)
			.then(function (value) {
				if (value.data.status === 10001) {
					that.headimgurl = value.data.img_orogin
					that.uploadMsg = ''
				}
				that.$refs.uploadPictureForm.reset()
			})
		},
		changeSelect (type) {
			this.selectI = type
			this.showViewRecord = (type === 0) ? false : true
		},
		getViewRecords () {
			let that = this
			that.c_ajax({user_id: that.$store.state.user_id}, 'api.php/User/review_lists', function (value) {
				if (value.data.status === 10001) {
					that.viewRecords = []
					for (let v of value.data.data) {
						that.viewRecords.push(v)
					}
				}
			})
		},
		removeViewRecord (id) {
			let that = this
			that.c_ajax({id: id}, 'api.php/User/review_del', function (value) {
				if (value.data.status === 10001) {
					that.showDialog(value.data.msg)
					setTimeout(function () {
						that.getViewRecords()
					}, 1500)
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		complete () {
			let that = this
			if (!this.sex) {
				that.showDialog('性别不能為空!')
				return
			}
			if (!this.ch_address) {
				that.showDialog('通訊地址不能為空!')
				return
			}
			if (!this.en_address) {
				that.showDialog('通訊地址不能為空!')
				return
			}
			if (!this.fax) {
				that.showDialog('傳真不能為空!')
				return
			}
			if (!this.xianzhi_unit) {
				that.showDialog('現職單位不能為空!')
				return
			}
			if (!this.gudong_unit) {
				that.showDialog('股東單位不能為空!')
				return
			}
			if (!this.chigu_rate) {
				that.showDialog('持股比例不能為空!')
				return
			}
			if (!this.job) {
				that.showDialog('職位不能為空!')
				return
			}
			if (!this.main_business) {
				that.showDialog('主要業務不能為空!')
				return
			}
			if (!this.gotime) {
				that.showDialog('何時來港工作不能為空!')
				return
			}
			if (!this.wherefrom) {
				that.showDialog('由何地來港不能為空!')
				return
			}
			if (!this.graduate_shcool) {
				that.showDialog('最後畢業院校不能為空!')
				return
			}
			if (!this.degree) {
				that.showDialog('獲得學位不能為空!')
				return
			}
			if (!this.major) {
				that.showDialog('專業不能為空!')
				return
			}
			if (!this.last_work_in) {
				that.showDialog('內地最後任職機構或就讀學校不能為空!')
				return
			}
			if (!this.forever_address) {
				that.showDialog('內地永久通訊地址不能為空!')
				return
			}
			if (!this.skill) {
				that.showDialog('本人專長不能為空!')
				return
			}
			if (!this.expect) {
				that.showDialog('對協會的期望不能為空!')
				return
			}
			let post = {
				applicant: this.applicant, sex: this.sex, ch_address: this.ch_address, en_address: this.en_address, tel: this.tel, fax: this.fax, email: this.email, xianzhi_unit: this.xianzhi_unit, gudong_unit: this.gudong_unit, chigu_rate: this.chigu_rate, job: this.job, main_business: this.main_business, gotime: new Date(this.gotime).getTime(), wherefrom: this.wherefrom, graduate_shcool: this.graduate_shcool, degree: this.degree, major: this.major, last_work_in: this.last_work_in, forever_address: this.forever_address, skill: this.skill, expect: this.expect, headimgurl: this.headimgurl, type: this.type,
			}
			that.c_ajax({post: post}, 'api.php/User/update', function (value) {
				that.showDialog(value.data.msg)
				that.uploadMsg = ''
			})
		},
	},
}
</script>

<style scoped>
.user_index {
}
.input-style {
	display: inline-block;
	height: 28px;
	outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/user_index.vue